<template>

  <div v-loading="allLoading" class="match-controller-container">

    <div class="controller-toolbar" style="
        height: 45px;
        line-height: 45px;
        font-size: 22px;
        background-color: rgb(247 244 244);;
        padding-left: 10px;
        font-weight: 600;
      ">
      {{ match ? match.MatchName : "" }}
      <!-- <el-checkbox-group v-model="checkMatchRegion" size="small" style="display: inline; margin:0 30px;">
        <el-checkbox v-for="item in matchRegions" :label="item.value" :key="item.value">{{ item.label }}</el-checkbox>
      </el-checkbox-group> -->

      <span style="
          margin-left: 10px;
          font-size: 12px;
          text-decoration: underline;
          cursor: pointer;
        " @click="showChoiceMatchDialogModel()">重新选择项目</span>

      <span style="margin: 0 5px 0 20px; font-size: 12px; font-weight: 600;text-decoration: underline;"
        @click="showChoiceMatchVenueDialogModel()">选择场次</span>

      <span style="margin: 0 5px 0 20px; font-size: 12px; font-weight: 600">自动刷新</span>
      <el-switch v-model="autoRefresh" active-text="" active-color="#13ce66" inactive-color="#ff4949">
      </el-switch>

      <!-- <span style="margin: 0 5px 0 20px; font-size: 12px; font-weight: 600">简约模式</span>
      <el-switch v-model="simpleMode" @change="modeChange" active-text="" active-color="#13ce66"
        inactive-color="#ff4949">
      </el-switch> -->
<span style="margin: 0 5px 0 20px; font-size: 12px; font-weight: 600"></span>
     

    </div>
    <div style="position: absolute; right: 40px; top: 30px; z-index: 999">
      <el-tooltip content="评分大屏" placement="bottom" effect="light">
        <el-button icon="el-icon-touping" style="font-size: 22px;" @click="showRefereeScore" circle></el-button>
      </el-tooltip>
    </div>
    <el-collapse v-model="activeNames" v-if="matchWholeSchedule" class="schedule-list" @change="handleVenueCollapseChange">
      <el-collapse-item :name="index" v-for="(item, index) in matchWholeSchedule" :key="item.VenueId">
        <template slot="title">
          <div class="venue-title">{{ item.VenueName }} {{ formatScheduleTime(item.VenueTime) }}~{{ formatScheduleTime(item.VenueEndTime) }}</div>
        </template>
        <div v-if="isVenueRendered(index)" v-show="activeNames.includes(index)" class="venue-projects">
          <section v-for="(project, projectIndex) in item.Projects" :key="project.ProjectName + '-' + projectIndex" class="project-section">
            <div class="project-title" @click="toggleProject(item, project, projectIndex)">
              <div class="project-title-text">
                <strong>{{ project.ProjectName }}</strong>
                <span v-if="project.ProjectTypeName && project.ProjectTypeName != project.ProjectName">{{ project.ProjectTypeName }}</span>
                <el-tag size="mini" type="info" class="project-group-count">共{{ (project.ArrangeGroups || []).length }}组</el-tag>
              </div>
              <i :class="isProjectOpen(item, project, projectIndex) ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            </div>
            <div v-if="isProjectRendered(item, project, projectIndex)" v-show="isProjectOpen(item, project, projectIndex)" class="project-groups">
              <div v-for="group in project.ArrangeGroups" :key="group.GroupNum" class="arrange-group">
                <div class="group-number">第{{ group.GroupNum }}组</div>
                <div class="regions-row">
                  <div v-for="region in group.Regions" :key="region.RegionId" class="region-block" :style="getRegionStyle(region, group)">
                    <div class="region-name">{{ region.RegionName }}</div>
                    <div class="region-users">
                      <div v-for="user in region.Users" :key="user.UserId" class="schedule-user">
                        <div class="user-number">
                          <span>{{ user.ComeOnNum }}号</span>
                          <el-tag v-if="user.GenderLabel" :type="user.GenderTagType" size="mini" class="gender-tag">
                            {{ user.GenderLabel }}
                          </el-tag>
                        </div>
                        <div class="user-group">{{ user.GroupName || '-' }}</div>
                        <div class="user-name">{{ user.UserName }}</div>
                        <div class="user-unit">{{ user.Unit || '-' }}</div>
                        <div class="user-status">
                          <el-dropdown trigger="click" @command="setUserStatus">
                            <el-button size="mini" :type="getStatusBtnType(user.Status)">
                              {{ user.StatusText || '未比赛' }}<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item :command="user.UserId + ':4:' + user.Score">弃赛</el-dropdown-item>
                              <el-dropdown-item :command="user.UserId + ':5:' + user.Score">违例</el-dropdown-item>
                              <el-dropdown-item :command="user.UserId + ':3:' + user.Score">已比赛</el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                          <div class="user-score-row">
                            <el-input-number v-if="user.IsSpeedProject && (user.Status == 2 || user.Status == 3)"
                              v-model="user.Score" :controls="false" size="mini" class="speed-score-input"
                              @change="editUserScore(user)"></el-input-number>
                            <span v-else-if="user.Status == 2 || user.Status == 3" class="user-score"
                              @click="showEditPointDialog(user.UserId)">{{ user.Score }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="region-actions">
                      <el-button type="primary" size="mini" v-if="region.ActionState.canPush" @click="pushMatchContestantUserSchedule(region.RegionName, region.RegionId, region)">推送终端</el-button>
                      <el-button type="primary" size="mini" v-if="region.ActionState.canPushAgain" @click="pushMatchContestantUserSchedule(region.RegionName, region.RegionId, region)">重新推送</el-button>
                      <el-button type="info" size="mini" v-if="region.ActionState.canCancel" @click="cancelMatchContestantUserSchedule1(region)">取消推送</el-button>
                      <el-button type="success" size="mini" v-if="region.ActionState.canComplete" @click="setMatchContestantUserComplete(region)">比赛完成</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-dialog title="选择赛事" :visible.sync="choiceMatchDialogVisible" :close-on-press-escape="true" :show-close="true"
      width="700px">
      <div style="width:80%;margin: 0px auto;">

        <el-select clearable filterable remote reserve-keyword placeholder="请输入关键词" size="small"
          style="width:100%;margin-bottom: 10px;" @change="handleMatchChange" :remote-method="remoteMethod"
          v-model="matchId">
          <el-option v-for="item in matchOptions" :label="item.MatchName" :value="item.MatchId">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="confirmChoiceMatch">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择赛事场次" :visible.sync="choiceMatchVenueDialogVisible" :close-on-press-escape="true"
      :show-close="true" width="700px">
      <div style="width:80%;margin: 0px auto;">

        <p style="margin-bottom: 10px;color:red;">由于参赛运动员众多，数据量较大，占用资源较大，请合理选择需要展示的场次</p>

        <el-checkbox-group v-model="checkVenueConfigs">
          <div>
            <el-checkbox v-for="item in matchVenueConfigs" :label="item.VenueId">{{ item.VenueName }}</el-checkbox>
          </div>
        </el-checkbox-group>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="choiceMatchVenueDialogVisible = false">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="在线裁判" :visible.sync="refereeDialogVisible" :close-on-press-escape="true" :show-close="true"
      width="80%">
      <div style="display: flex; flex-wrap: wrap; width: 100%">
        <div style="width: 20%; box-sizing: border-box" v-for="item in onLineReferee">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>场地{{ item.SiteNum }}</span>
            </div>
            <div class="text item" v-for="type in item.RefereeTypes">
              <div>
                <div>
                  {{ type.RefereeTypeName }}:
                  <span v-for="referee in type.Referees" style="color: blue; margin-right: 5px">{{ referee.RefereeName
                  }}</span>
                </div>
              </div>
            </div>
          </el-card>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="getOnLineReferee">刷新</el-button>
        <el-button size="small" @click="refereeDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="setUserStatusDialogVisible" :close-on-press-escape="true" :show-close="true"
      width="400px">
      <div>
        <p>
          是否确认将该运动员设为{{
            setUserStatusForm.Status == 4 ? "弃赛?" : setUserStatusForm.Status == 5 ? "违例?" : setUserStatusForm.Status == 3
              ?
              "已比赛?" : "未知状态"
          }}
        </p>
        <!-- <p></p>
        <el-input v-if="setUserStatusForm.Status == 3" v-model="setUserStatusForm.Score" size="small"
          placeholder="比赛成绩"></el-input> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="submitSetUserStatus">确定</el-button>
        <el-button size="small" type="info" @click="setUserStatusDialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="运动员成绩" class="adaptive" :visible.sync="editPointDialogVisible" :show-close="true"
      :close-on-press-escape="true" :close-on-click-modal="false" :fullscreen="true">

      <div
        v-if="userScoreDetail.Project && (userScoreDetail.Project.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D' || userScoreDetail.Project.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C')">
        <table>
          <tr>
            <th>主裁扣分</th>
            <th>D难度</th>
            <th>U重复</th>
            <th>P完成</th>
            <th>Q规定</th>
            <th>M失误</th>
            <th>R成绩</th>
          </tr>
          <tr>
            <td>{{ userScoreDetail.DeductPointScore > 0 ? userScoreDetail.DeductPointScore * -1 : 0 }}</td>
            <td>{{ userScoreDetail.D_Score }}</td>
            <td>{{ userScoreDetail.U_Score }}</td>
            <td>{{ userScoreDetail.P_Score }}</td>
            <td>{{ userScoreDetail.Q_Score }}</td>
            <td>{{ userScoreDetail.M_Score }}</td>
            <td>{{ userScoreDetail.TotalScore }}</td>
          </tr>
        </table>
      </div>

      <!-- 国内赛 -->
      <div v-if="userScoreDetail.Project
        && (userScoreDetail.Project.ProjectTypeId == 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
          || userScoreDetail.Project.ProjectTypeId == 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'
          || userScoreDetail.Project.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
          || userScoreDetail.Project.ProjectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095'
          || userScoreDetail.Project.ProjectTypeId == '7427106A-8F3D-4990-803E-C10B92ED618F'
          || userScoreDetail.Project.ProjectTypeId == 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'
          || userScoreDetail.Project.ProjectTypeId == 'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A'
        )">
        <table>
          <tr>
            <th>主裁扣分</th>
            <th v-if="userScoreDetail.Project.ProjectTypeId != 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
              && userScoreDetail.Project.ProjectTypeId != 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'">难度</th>
            <th v-if="userScoreDetail.Project.ProjectTypeId != 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
              && userScoreDetail.Project.ProjectTypeId != 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'">重复难度
            </th>
            <th v-if="userScoreDetail.Project.ProjectTypeId != '7427106A-8F3D-4990-803E-C10B92ED618F'
              && userScoreDetail.Project.ProjectTypeId != 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">创意编排
            </th>
            <th v-if="userScoreDetail.Project.ProjectTypeId != '7427106A-8F3D-4990-803E-C10B92ED618F'
              && userScoreDetail.Project.ProjectTypeId != 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">完成质量
            </th>
            <th v-if="userScoreDetail.Project.ProjectTypeId != 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
              && userScoreDetail.Project.ProjectTypeId != 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'
              && userScoreDetail.Project.ProjectTypeId != '7427106A-8F3D-4990-803E-C10B92ED618F'
              && userScoreDetail.Project.ProjectTypeId != 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">规定元素
            </th>
            <th>总分</th>
          </tr>
          <tr>
            <td>{{ userScoreDetail.DeductPointScore > 0 ? userScoreDetail.DeductPointScore * -1 : 0 }}</td>
            <td v-if="userScoreDetail.Project.ProjectTypeId != 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
              && userScoreDetail.Project.ProjectTypeId != 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'">
              {{ userScoreDetail.D_Portion_Score }}</td>
            <td v-if="userScoreDetail.Project.ProjectTypeId != 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
              && userScoreDetail.Project.ProjectTypeId != 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'">
              {{ userScoreDetail.U_Portion_Score }}</td>
            <td v-if="userScoreDetail.Project.ProjectTypeId != '7427106A-8F3D-4990-803E-C10B92ED618F'
              && userScoreDetail.Project.ProjectTypeId != 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">{{
                userScoreDetail.CA_Score }}</td>
            <td v-if="userScoreDetail.Project.ProjectTypeId != '7427106A-8F3D-4990-803E-C10B92ED618F'
              && userScoreDetail.Project.ProjectTypeId != 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">{{
                userScoreDetail.CQ_Score }}</td>
            <td v-if="userScoreDetail.Project.ProjectTypeId != 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
              && userScoreDetail.Project.ProjectTypeId != 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'
              && userScoreDetail.Project.ProjectTypeId != '7427106A-8F3D-4990-803E-C10B92ED618F'
              && userScoreDetail.Project.ProjectTypeId != 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">
              {{ userScoreDetail.Q_Score }}</td>
            <td>{{ userScoreDetail.FinalTotalScore }}</td>
          </tr>
        </table>
      </div>

      <!--扣分次数-->
      <div class="score-group-item">
        <table border="1">
          <tr>
            <th colspan="2">扣分次数</th>
            <th><el-button size="mini" @click="addScoreGroup('扣分次数')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              裁判
            </th>
            <th>
              次数
            </th>
            <th>操作</th>
          </tr>

          <tr v-for="(item, index) in userScoreDetail.DeductPointItems">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input-number v-model="item.DeductPointCount" controls-position="right" size="mini"
                style="width: 110px;" @change="calcScore"></el-input-number>

            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.DeductPointItems, index)"></i>
            </td>
          </tr>
        </table>
      </div>

      <!--计次-->
      <div class="score-group-item"
        v-if="userScoreDetail.Project && userScoreDetail.Project.ProjectTypeId == 'F679B7E4-F852-4A2A-BAF2-EC21BE923826'">
        <table border="1">
          <tr>
            <th colspan="2">计次</th>
            <th><el-button size="mini" @click="addScoreGroup('计次')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              裁判
            </th>
            <th>
              次数
            </th>
            <th>操作</th>
          </tr>

          <tr v-for="(item, index) in userScoreDetail.Times">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input-number v-model="item.Times" controls-position="right" size="mini"
                style="width: 110px;"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.Times, index)"></i>
            </td>
          </tr>
        </table>
      </div>

      <!--创意编排分-->
      <div class="score-group-item"
        v-if="userScoreDetail.Project && userScoreDetail.Project.ProjectTypeId == 'A8CF0C94-4A2B-495C-8E4C-861357928917'">
        <table border="1">
          <tr>
            <th colspan="2">创意编排分</th>
            <th><el-button size="mini" @click="addScoreGroup('创意编排分')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              裁判
            </th>
            <th>
              分数
            </th>
            <th>操作</th>
          </tr>

          <tr v-for="(item, index) in userScoreDetail.CreativeArrangementGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input-number v-model="item.Score" controls-position="right" size="mini"
                style="width: 110px;"></el-input-number>
            </td>
            <td> <i class="el-icon-delete"
                @click="delScoreGroupItem(userScoreDetail.CreativeArrangementGroups, index)"></i>
            </td>
          </tr>
        </table>
      </div>

      <!--完成质量分-->
      <div class="score-group-item"
        v-if="userScoreDetail.Project && userScoreDetail.Project.ProjectTypeId == 'A8CF0C94-4A2B-495C-8E4C-861357928917'">
        <table border="1">
          <tr>
            <th colspan="2">完成质量分</th>
            <th><el-button size="mini" @click="addScoreGroup('完成质量分')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              裁判
            </th>
            <th>
              分数
            </th>
            <th>操作</th>
          </tr>

          <tr v-for="(item, index) in userScoreDetail.CompletionQualityGroups">
            <td>
              <el-select size="mini" v-model="item.referee.RefereeId" filterable placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
              <!-- {{ item.referee.RefereeName }} -->
            </td>
            <td>
              <el-input-number v-model="item.Score" controls-position="right" size="mini"
                style="width: 110px;"></el-input-number>
            </td>
            <td>
              <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.CompletionQualityGroups, index)"></i>
            </td>
          </tr>
        </table>
      </div>

      <!--难度分D-->
      <div class="score-group-item"
        v-if="userScoreDetail.Project && (userScoreDetail.Project.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D' || userScoreDetail.Project.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C')">
        <table border="1">
          <tr>
            <th colspan="10">难度分D</th>
            <th><el-button size="mini" @click="addScoreGroup('难度分D')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              等级
            </th>
            <th v-for="item in score.d">
              {{ item.l }}级
            </th>
            <th rowspan="2" style="width: 50px;">操作</th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th v-for="item in score.d">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.D_ScoreGroups">
            <td style="width: 120px;">
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.D_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
      </div>

      <!--重复难度U-->
      <div class="score-group-item"
        v-if="userScoreDetail.Project && (userScoreDetail.Project.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D' || userScoreDetail.Project.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C')">
        <table border="1">
          <tr>
            <th colspan="7">重复难度U</th>
            <th><el-button size="mini" @click="addScoreGroup('重复难度U')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              等级
            </th>
            <th v-for="item in score.u">
              {{ item.l }}级
            </th>
            <th rowspan="2">操作</th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th v-for="item in score.u">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.U_ScoreGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.U_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
      </div>

      <!--完成分-->
      <div class="score-group-item" style="display: flex;"
        v-if="userScoreDetail.Project && (userScoreDetail.Project.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D' || userScoreDetail.Project.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C')">
        <table border="1">
          <tr>
            <th colspan="4">Pa动作技能</th>
            <th><el-button size="mini" @click="addScoreGroup('Pa动作技能')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              记录
            </th>
            <th v-for="item in score.p.pa">
              {{ item.l }}
            </th>
            <th rowspan="2">操作</th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th v-for="item in score.p.pa">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.Pa_ScoreGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.Pa_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>

        <table border="1">
          <tr>
            <th colspan="4">Pr娱乐编排</th>
            <th><el-button size="mini" @click="addScoreGroup('Pr娱乐编排')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              记录
            </th>
            <th v-for="item in score.p.pre">
              {{ item.l }}
            </th>
            <th rowspan="2">操作</th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th v-for="item in score.p.pre">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.Pr_E_ScoreGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.Pr_E_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>

        <table border="1">
          <tr>
            <th colspan="4">Pr音乐运用</th>
            <th><el-button size="mini" @click="addScoreGroup('Pr音乐运用')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              记录
            </th>
            <th v-for="item in score.p.prm">
              {{ item.l }}
            </th>
            <th rowspan="2">操作</th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th v-for="item in score.p.prm">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.Pr_M_ScoreGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.Pr_M_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
      </div>
      <!--Fs形式风格-->
      <div class="score-group-item"
        v-if="userScoreDetail.Project && userScoreDetail.Project.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C'">
        <table border="1">
          <tr>
            <th colspan="4">Fs形式风格</th>
            <th>
              <el-button size="mini" @click="addScoreGroup('Fs形式风格')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              记录
            </th>
            <th v-for="item in score.p.fs">
              {{ item.l }}
            </th>
            <th rowspan="2">操作</th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th v-for="item in score.p.fs">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.FS_ScoreGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.FS_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
      </div>
      <!-- 集体自编规定分 -->
      <div class="score-group-item" style="display: flex;"
        v-if="userScoreDetail.Project && (userScoreDetail.Project.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C')">
        <table border="1"">
                    <tr>
                        <th colspan=" 6">规定Q</th>
          <th><el-button size="mini" @click="addScoreGroup('【集体自编赛】规定Q')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              类别
            </th>
            <th v-for="item in score.c_q">
              {{ item.l }}
            </th>
            <th rowspan="2">操作</th>
          </tr>
          <tr>
            <th>
              满分数
            </th>
            <th v-for="item in score.c_q">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.Q_ScoreGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" :min="0" :max="s.MaxScoreValue"
                style="width: 110px;" @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.Q_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
      </div>
      <!--规定分、失误违例-->
      <div class="score-group-item" style="display: flex;"
        v-if="userScoreDetail.Project && (userScoreDetail.Project.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D' || userScoreDetail.Project.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C')">
        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D'">
          <tr>
            <th colspan="4">规定Q</th>
            <th><el-button size="mini" @click="addScoreGroup('规定Q')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              类别
            </th>
            <th v-for="item in score.q">
              {{ item.l }}
            </th>
            <th rowspan="2">操作</th>
          </tr>
          <tr>
            <th>
              满分数
            </th>
            <th v-for="item in score.q">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.Q_ScoreGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" :min="0" :max="s.MaxScoreValue"
                style="width: 110px;" @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.Q_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>

        <table border="1">
          <tr>
            <th colspan="2">Pa失误</th>
            <th><el-button size="mini" @click="addScoreGroup('Pa失误')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              裁判
            </th>
            <th>
              次数
            </th>
            <th>操作</th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.Mistake_Pa_ScoreGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input-number v-model="item.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete"
                @click="delScoreGroupItem(userScoreDetail.Mistake_Pa_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>

        <table border="1">
          <tr>
            <th colspan="2">Q失误</th>
            <th><el-button size="mini" @click="addScoreGroup('Q失误')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              裁判
            </th>
            <th>
              次数
            </th>
            <th>操作</th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.Mistake_Q_ScoreGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input-number v-model="item.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.Mistake_Q_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>

        <table border="1">
          <tr>
            <th colspan="2">违例</th>
            <th><el-button size="mini" @click="addScoreGroup('违例')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              裁判
            </th>
            <th>
              次数
            </th>
            <th>操作</th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.V_ScoreGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input-number v-model="item.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.V_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
      </div>

      <!-- 国内个人规定赛，集体规定赛 完成质量/创意编排-->
      <div class="score-group-item" style="display: flex;" v-if="userScoreDetail.Project && (userScoreDetail.Project.ProjectTypeId == 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
        || userScoreDetail.Project.ProjectTypeId == 'FA8BBD50-62E3-47A0-A611-F70D34F29A67')">
        <table border="1"
          v-if="userScoreDetail.Project && userScoreDetail.Project.ProjectTypeId == 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'">
          <tr>
            <th colspan="4">完成质量</th>
            <th><el-button size="mini" @click="addScoreGroup('【国内个人规定赛】完成质量')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              因素
            </th>
            <th v-for="item in score.cpr_cq">
              {{ item.t }}
            </th>
            <th rowspan="2">操作</th>
          </tr>
          <tr>
            <th>
              满分数
            </th>
            <th v-for="item in score.cpr_cq">
              {{ item.m }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.CompletionQualityGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" :min="0" :max="s.MaxScoreValue"
                style="width: 110px;" @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete"
                @click="delScoreGroupItem(userScoreDetail.CompletionQualityGroups, index)"></i>
            </td>
          </tr>
        </table>
        <table border="1"
          v-if="userScoreDetail.Project && userScoreDetail.Project.ProjectTypeId == 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'">
          <tr>
            <th colspan="6">完成质量</th>
            <th>
              <el-button size="mini" @click="addScoreGroup('【国内集体规定赛】完成质量')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              因素
            </th>
            <th v-for="item in score.ctr_cq">
              {{ item.t }}
            </th>
            <th rowspan="2">操作</th>
          </tr>
          <tr>
            <th>
              满分数
            </th>
            <th v-for="item in score.ctr_cq">
              {{ item.m }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.CompletionQualityGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" :min="0" :max="s.MaxScoreValue"
                style="width: 110px;" @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete"
                @click="delScoreGroupItem(userScoreDetail.CompletionQualityGroups, index)"></i>
            </td>
          </tr>
        </table>
        <table border="1">
          <tr>
            <th colspan="3">创意编排</th>
            <th><el-button size="mini" @click="addScoreGroup('【国内个人/集体规定赛】创意编排')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              因素
            </th>
            <th v-for="item in score.cr_ca">
              {{ item.t }}
            </th>
            <th rowspan="2">操作</th>
          </tr>
          <tr>
            <th>
              满分数
            </th>
            <th v-for="item in score.cr_ca">
              {{ item.m }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.CreativeArrangementGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" :min="0" :max="s.MaxScoreValue"
                style="width: 110px;" @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete"
                @click="delScoreGroupItem(userScoreDetail.CreativeArrangementGroups, index)"></i>
            </td>
          </tr>
        </table>
      </div>
      <!-- 国内表演赛/花样赛 难度分 -->
      <div class="score-group-item" style="display: flex;" v-if="userScoreDetail.Project && ['39E56A5E-CB75-4245-AA8C-C0553C6C4ADF',
        '528D50AF-3268-45B7-A0B2-6C25D6759095',
        'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A',
        '7427106A-8F3D-4990-803E-C10B92ED618F',
        'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3']
        .indexOf(userScoreDetail.Project.ProjectTypeId) > -1">
        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId != 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">
          <tr>
            <th colspan="2">{{ this.score.c_d1.l }}</th>
            <th><el-button size="mini" @click="addScoreGroup('一级难度')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th>
              {{ this.score.c_d1.v }}
            </th>
            <th>操作</th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.D1_ScoreGroups">
            <td>
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input-number v-model="item.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>

            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.D1_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>

        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId != '7427106A-8F3D-4990-803E-C10B92ED618F'">
          <tr>
            <th colspan="2">{{ this.score.c_d2.l }}</th>
            <th><el-button size="mini" @click="addScoreGroup('二级难度')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th>
              {{ this.score.c_d2.v }}
            </th>
            <th>操作</th>
          </tr>

          <tr v-for="(item, index) in userScoreDetail.D2_ScoreGroups">
            <td>
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input-number v-model="item.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>

            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.D2_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
        <!-- 非国内集体个人花样显示-->
        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId != '7427106A-8F3D-4990-803E-C10B92ED618F'
          && userScoreDetail.Project.ProjectTypeId != 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">
          <tr>
            <th colspan="2">{{ this.score.c_d3.l }}</th>
            <th><el-button size="mini" @click="addScoreGroup('三级难度')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th>
              {{ this.score.c_d3.v }}
            </th>
            <th>操作</th>
          </tr>

          <tr v-for="(item, index) in userScoreDetail.D3_ScoreGroups">
            <td>
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input-number v-model="item.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>

            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.D3_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
      </div>
      <!-- 国内表演赛/花样赛 重复难度分 -->
      <div class="score-group-item" style="display: flex;" v-if="userScoreDetail.Project && ['39E56A5E-CB75-4245-AA8C-C0553C6C4ADF',
        '528D50AF-3268-45B7-A0B2-6C25D6759095',
        'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A',
        '7427106A-8F3D-4990-803E-C10B92ED618F',
        'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3']
        .indexOf(userScoreDetail.Project.ProjectTypeId) > -1">
        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId != 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">
          <tr>
            <th colspan="2">重复{{ this.score.c_u1.l }}</th>
            <th><el-button size="mini" @click="addScoreGroup('重复一级难度')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th>
              {{ this.score.c_u1.v }}
            </th>
            <th>操作</th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.U1_ScoreGroups">
            <td>
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input-number v-model="item.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>

            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.U1_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>

        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId != '7427106A-8F3D-4990-803E-C10B92ED618F'">
          <tr>
            <th colspan="2">重复{{ this.score.c_u2.l }}</th>
            <th><el-button size="mini" @click="addScoreGroup('重复二级难度')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th>
              {{ this.score.c_u2.v }}
            </th>
            <th>操作</th>
          </tr>

          <tr v-for="(item, index) in userScoreDetail.U2_ScoreGroups">
            <td>
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input-number v-model="item.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>

            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.U2_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
        <!-- 非国内集体个人花样显示-->
        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId != '7427106A-8F3D-4990-803E-C10B92ED618F'
          && userScoreDetail.Project.ProjectTypeId != 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">
          <tr>
            <th colspan="2">重复{{ this.score.c_u3.l }}</th>
            <th><el-button size="mini" @click="addScoreGroup('重复三级难度')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th>
              {{ this.score.c_u3.v }}
            </th>
            <th>操作</th>
          </tr>

          <tr v-for="(item, index) in userScoreDetail.U3_ScoreGroups">
            <td>
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input-number v-model="item.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>

            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.U3_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
      </div>
      <!-- 国内表演赛/花样赛 完成质量/创意编排分 -->
      <div class="score-group-item" style="display: flex;" v-if="userScoreDetail.Project
        && (userScoreDetail.Project.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
          || userScoreDetail.Project.ProjectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095'
          || userScoreDetail.Project.ProjectTypeId == 'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A')">
        <table border="1">
          <tr>
            <th colspan="6">创意编排</th>
            <th><el-button size="mini" @click="addScoreGroup('【国内表演赛/花样赛】创意编排')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              因素
            </th>
            <th v-for="item in score.c_ca">
              {{ item.t }}
            </th>
            <th rowspan="2">操作</th>
          </tr>
          <tr>
            <th>
              满分数
            </th>
            <th v-for="item in score.c_ca">
              {{ item.m }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.CA_ScoreGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" :min="0" :max="s.MaxScore"
                style="width: 110px;" @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.CA_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
        <table border="1">
          <tr>
            <th colspan="5">完成质量</th>
            <th>
              <el-button size="mini" @click="addScoreGroup('【国内表演赛/花样赛】完成质量')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              因素
            </th>
            <th v-for="item in score.c_cq">
              {{ item.l }}
            </th>
            <th rowspan="2">操作</th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th v-for="item in score.c_cq">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.CQ_ScoreGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" :min="0" :max="s.MaxScore"
                style="width: 110px;" @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.CQ_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
      </div>
      <!-- 国内表演赛 规定元素 -->
      <div class="score-group-item" style="display: flex;" v-if="userScoreDetail.Project
        && (userScoreDetail.Project.ProjectTypeId == 'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A')">
        <table border="1">
          <tr>
            <th colspan="6">规定元素</th>
            <th><el-button size="mini" @click="addScoreGroup('【国内表演赛】规定元素')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              因素
            </th>
            <th v-for="item in score.c_q">
              {{ item.l }}
            </th>
            <th rowspan="2">操作</th>
          </tr>
          <tr>
            <th>
              次数
            </th>
            <th v-for="item in score.c_q">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.Q_ScoreGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Frequency" controls-position="right" size="mini" :min="0"
                :max="s.MustFrequency" style="width: 110px;" @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.Q_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
      </div>
      <!-- 国内花样赛 规定元素 -->
      <div class="score-group-item" style="display: flex;" v-if="userScoreDetail.Project
        && (userScoreDetail.Project.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
          || userScoreDetail.Project.ProjectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095')">

        <table border="1">
          <tr>
            <th colspan="5">规定元素<span style="color:red !important;">(注意：裁判无需打分的项请留空，该项不会加入平均分的计算)</span>
            </th>
            <th><el-button size="mini" @click="addScoreGroup('【国内花样赛】规定元素')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              因素
            </th>
            <th v-for="item in score.c_q2">
              {{ item.l }}
            </th>
            <th rowspan="2">操作</th>
          </tr>
          <tr>
            <th>
              次数
            </th>
            <th v-for="item in score.c_q2">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.Q_ScoreGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input type="number" v-model="s.Frequency" controls-position="right" size="mini" :disabled="userScoreDetail.Project.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
                && s.Type == '互相配合'" :max="s.MustFrequency" style="width: 110px;" @change="calcScore"></el-input>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.Q_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>

      </div>

      <!--精英花样难度分/精英级表演赛-->
      <!--难度分D-->
      <div class="score-group-item" v-if="userScoreDetail.Project &&
        (userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
          || userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
          || userScoreDetail.Project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
          || userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
          || userScoreDetail.Project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
          || userScoreDetail.Project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
          || userScoreDetail.Project.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
          || userScoreDetail.Project.ProjectTypeId == '5874F99D-0D4F-49F6-A3A6-BE4867F652B8'
        )">
        <!--DP难度分-->
        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
          || userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'">

          <tr>
            <th colspan="10">DP难度分</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DP难度分')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              等级
            </th>
            <th v-for="item in score.dp">
              {{ item.l }}级
            </th>
            <th rowspan="2" style="width: 50px;">操作</th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th v-for="item in score.dp">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.DP_ScoreGroups">
            <td style="width: 120px;">
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.DP_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
        <!--DM难度分-->
        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
          || userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'">
          <tr>
            <th colspan="10">DM难度分</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DM难度分')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              等级
            </th>
            <th v-for="item in score.dm">
              {{ item.l }}级
            </th>
            <th rowspan="2" style="width: 50px;">操作</th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th v-for="item in score.dm">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.DM_ScoreGroups">
            <td style="width: 120px;">
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.DM_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
        <!--DR难度分-->
        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
          || userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'">

          <tr>
            <th colspan="10">DR难度分</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DR难度分')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              等级
            </th>
            <th v-for="item in score.dr">
              {{ item.l }}级
            </th>
            <th rowspan="2" style="width: 50px;">操作</th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th v-for="item in score.dr">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.DR_ScoreGroups">
            <td style="width: 120px;">
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.DR_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
        <!--DA难度分-->
        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
          || userScoreDetail.Project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
        ">
          <tr>
            <th colspan="10">DA难度分</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DA难度分')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              等级
            </th>
            <th v-for="item in score.da">
              {{ item.l }}级
            </th>
            <th rowspan="2" style="width: 50px;">操作</th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th v-for="item in score.da">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.DA_ScoreGroups">
            <td style="width: 120px;">
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.DA_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
        <!--DB难度分-->
        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
          || userScoreDetail.Project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'">
          <tr>
            <th colspan="10">DB难度分</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DB难度分')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              等级
            </th>
            <th v-for="item in score.db">
              {{ item.l }}级
            </th>
            <th rowspan="2" style="width: 50px;">操作</th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th v-for="item in score.db">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.DB_ScoreGroups">
            <td style="width: 120px;">
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.DB_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
        <!--DJ难度分-->
        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
          || userScoreDetail.Project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'">
          <tr>
            <th colspan="16">DJ难度分</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DJ难度分')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              等级
            </th>
            <th v-for="item in score.dj">
              {{ item.l }}级
            </th>
            <th rowspan="2" style="width: 50px;">操作</th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th v-for="item in score.dj">
              {{ item.v.toFixed(2) }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.DJ_ScoreGroups">
            <td style="width: 120px;">
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.DJ_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
        <!--DT难度分-->
        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
          || userScoreDetail.Project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'">
          <tr>
            <th colspan="16">DT难度分</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DT难度分')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              等级
            </th>
            <th v-for="item in score.dt">
              {{ item.l }}级
            </th>
            <th rowspan="2" style="width: 50px;">操作</th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th v-for="item in score.dt">
              {{ item.v.toFixed(2) }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.DT_ScoreGroups">
            <td style="width: 120px;">
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.DT_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
      </div>
      <!--重复难度U-->
      <div class="score-group-item" v-if="userScoreDetail.Project &&
        (userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
          || userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
          || userScoreDetail.Project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
          || userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
          || userScoreDetail.Project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
          || userScoreDetail.Project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
          || userScoreDetail.Project.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
          || userScoreDetail.Project.ProjectTypeId == '5874F99D-0D4F-49F6-A3A6-BE4867F652B8'
        )">
        <!--DP重复难度分-->
        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
          || userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'">

          <tr>
            <th colspan="10">DP重复难度分</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DP重复难度分')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              等级
            </th>
            <th v-for="item in score.u_dp">
              {{ item.l }}级
            </th>
            <th rowspan="2" style="width: 50px;">操作</th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th v-for="item in score.u_dp">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.UDP_ScoreGroups">
            <td style="width: 120px;">
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.UDP_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
        <!--DM重复难度分-->
        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
          || userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'">
          <tr>
            <th colspan="10">DM重复难度分</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DM重复难度分')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              等级
            </th>
            <th v-for="item in score.u_dm">
              {{ item.l }}级
            </th>
            <th rowspan="2" style="width: 50px;">操作</th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th v-for="item in score.u_dm">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.UDM_ScoreGroups">
            <td style="width: 120px;">
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.UDM_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
        <!--DR重复难度分-->
        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
          || userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'">
          <tr>
            <th colspan="10">DR重复难度分</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DR重复难度分')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              等级
            </th>
            <th v-for="item in score.u_dr">
              {{ item.l }}级
            </th>
            <th rowspan="2" style="width: 50px;">操作</th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th v-for="item in score.u_dr">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.UDR_ScoreGroups">
            <td style="width: 120px;">
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.UDR_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
        <!--DA重复难度分-->
        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
          || userScoreDetail.Project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'">
          <tr>
            <th colspan="10">DA重复难度分</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DA重复难度分')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              等级
            </th>
            <th v-for="item in score.u_da">
              {{ item.l }}级
            </th>
            <th rowspan="2" style="width: 50px;">操作</th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th v-for="item in score.u_da">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.UDA_ScoreGroups">
            <td style="width: 120px;">
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.UDA_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
        <!--DB重复难度分-->
        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
          || userScoreDetail.Project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'">
          <tr>
            <th colspan="10">DB重复难度分</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DB重复难度分')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              等级
            </th>
            <th v-for="item in score.u_db">
              {{ item.l }}级
            </th>
            <th rowspan="2" style="width: 50px;">操作</th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th v-for="item in score.u_db">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.UDB_ScoreGroups">
            <td style="width: 120px;">
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.UDB_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
        <!--DT重复难度分-->
        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
          || userScoreDetail.Project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'">
          <tr>
            <th colspan="16">DT重复难度分</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DT重复难度分')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              等级
            </th>
            <th v-for="item in score.u_dt">
              {{ item.l }}级
            </th>
            <th rowspan="2" style="width: 50px;">操作</th>
          </tr>
          <tr>
            <th>
              分值
            </th>
            <th v-for="item in score.u_dt">
              {{ item.v.toFixed(2) }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.UDT_ScoreGroups">
            <td style="width: 120px;">
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.UDT_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
      </div>
      <!--表现分P-->
      <div class="score-group-item" style="display: flex;flex-wrap: wrap;" v-if="userScoreDetail.Project &&
        (userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
          || userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
          || userScoreDetail.Project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
          || userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
          || userScoreDetail.Project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
          || userScoreDetail.Project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
          || userScoreDetail.Project.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
          || userScoreDetail.Project.ProjectTypeId == '5874F99D-0D4F-49F6-A3A6-BE4867F652B8'
        )">
        <!--音乐-->
        <table border="1">

          <tr>
            <th colspan="16">表现分P</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】表现P')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>类型</th>
            <th colspan="3">音乐</th>
            <th colspan="3">完成质量</th>
            <th colspan="3">创意</th>
            <th colspan="3">娱乐</th>
            <th colspan="3">多样性/重复性</th>
            <th rowspan="3">操作</th>
          </tr>
          <tr>
            <th>
              记录
            </th>
            <th v-for="item in score.p2.m">
              {{ item.l }}
            </th>
            <th v-for="item in score.p2.cq">
              {{ item.l }}
            </th>
            <th v-for="item in score.p2.ca">
              {{ item.l }}
            </th>
            <th v-for="item in score.p2.r">
              {{ item.l }}
            </th>
            <th v-for="item in score.p2.v">
              {{ item.l }}
            </th>

          </tr>
          <tr>
            <th>
              分值
            </th>
            <th v-for="item in score.p2.m">
              {{ item.v }}
            </th>
            <th v-for="item in score.p2.cq">
              {{ item.v }}
            </th>
            <th v-for="item in score.p2.ca">
              {{ item.v }}
            </th>
            <th v-for="item in score.p2.r">
              {{ item.v }}
            </th>
            <th v-for="item in score.p2.v">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.P_ScoreGroups">
            <td>
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.P_M_ScoreGroups">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td v-for="s in item.P_CQ_ScoreGroups">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td v-for="s in item.P_CA_ScoreGroups">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td v-for="s in item.P_R_ScoreGroups">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td v-for="s in item.P_V_ScoreGroups">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.P_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
      </div>
      <!--花样 规定元素-->
      <div class="score-group-item" style="display: flex;" v-if="userScoreDetail.Project &&
        (userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
          || userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
        )">
        <!--力量体操-->
        <table border="1">
          <tr>
            <th colspan="3">力量体操</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样】规定元素Q-力量体操')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              等级
            </th>
            <th>
              {{ score.q2.p[0].l }}
            </th>
            <th>
              {{ score.q2.p[1].l }}
            </th>
            <th rowspan="1">操作</th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.Q_P_ScoreGroups">
            <td>
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.Q_P_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
        <!--多摇-->
        <table border="1">
          <tr>
            <th colspan="3">多摇</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样】规定元素Q-多摇')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              等级
            </th>
            <th>
              {{ score.q2.m[0].l }}
            </th>
            <th>
              {{ score.q2.m[1].l }}
            </th>
            <th rowspan="1">操作</th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.Q_M_ScoreGroups">
            <td>
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.Q_M_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
        <!--绳子运用-->
        <table border="1">
          <tr>
            <th colspan="3">绳子运用</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样】规定元素Q-绳子运用')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              等级
            </th>
            <th>
              {{ score.q2.r[0].l }}
            </th>
            <th>
              {{ score.q2.r[1].l }}
            </th>
            <th rowspan="1">操作</th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.Q_R_ScoreGroups">
            <td>
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.Q_R_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
        <!--相互配合-->
        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'">
          <tr>
            <th colspan="3">相互配合</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样】规定元素Q-互相配合')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              等级
            </th>
            <th>
              {{ score.q2.i[0].l }}
            </th>
            <th>
              {{ score.q2.i[1].l }}
            </th>
            <th rowspan="1">操作</th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.Q_I_ScoreGroups">
            <td>
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.Q_I_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
      </div>
      <!--表演赛 规定元素-->
      <div class="score-group-item" style="display: flex;" v-if="userScoreDetail.Project
        && (userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
          // || userScoreDetail.Project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
          || userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
          || userScoreDetail.Project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
          || userScoreDetail.Project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD')
      ">
        <table border="1">
          <tr>
            <th colspan="6">规定元素</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级表演赛】规定元素')" plain>添加组数</el-button>
            </th>
          </tr>
          <tr>
            <th>
              因素
            </th>
            <th v-for="item in score.e_q">
              {{ item.l }}
            </th>
            <th rowspan="2">操作</th>
          </tr>
          <tr>
            <th>
              次数
            </th>
            <th v-for="item in score.e_q">
              {{ item.v }}
            </th>
          </tr>
          <tr v-for="(item, index) in userScoreDetail.Q_ScoreGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td v-for="s in item.Items">
              <el-input-number v-model="s.Frequency" controls-position="right" size="mini" :min="0"
                :max="s.MustFrequency" style="width: 110px;" @change="calcScore"></el-input-number>
            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.Q_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
      </div>

      <!--花样 扣分M-->
      <div class="score-group-item" style="display: flex;" v-if="userScoreDetail.Project &&
        (userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
          || userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
          || userScoreDetail.Project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
        )">
        <table border="1">
          <tr>
            <th colspan="2">失误m</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】失误m')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              裁判
            </th>
            <th>
              次数
            </th>
            <th>操作</th>
          </tr>

          <tr v-for="(item, index) in userScoreDetail.M_M_ScoreGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input-number v-model="item.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>

            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.M_M_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
        <table border="1" v-if="userScoreDetail.Project.ProjectTypeId != '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'">
          <tr>
            <th colspan="2">间歇b</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样】间歇b')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              裁判
            </th>
            <th>
              次数
            </th>
            <th>操作</th>
          </tr>

          <tr v-for="(item, index) in userScoreDetail.M_B_ScoreGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input-number v-model="item.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>

            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.M_B_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
        <table border="1">
          <tr>
            <th colspan="2">违例v</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】违例v')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              裁判
            </th>
            <th>
              次数
            </th>
            <th>操作</th>
          </tr>

          <tr v-for="(item, index) in userScoreDetail.M_V_ScoreGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input-number v-model="item.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>

            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.M_V_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
      </div>
      <!--表演赛 扣分M-->
      <div class="score-group-item" style="display: flex;" v-if="userScoreDetail.Project &&
        (userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
          || userScoreDetail.Project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
          || userScoreDetail.Project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
          || userScoreDetail.Project.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
          || userScoreDetail.Project.ProjectTypeId == '5874F99D-0D4F-49F6-A3A6-BE4867F652B8'
        )">
        <table border="1">
          <tr>
            <th colspan="2">失误m</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】失误m')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              裁判
            </th>
            <th>
              次数
            </th>
            <th>操作</th>
          </tr>

          <tr v-for="(item, index) in userScoreDetail.M_M_ScoreGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input-number v-model="item.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>

            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.M_M_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>

        <table border="1">
          <tr>
            <th colspan="2">违例v</th>
            <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】违例v')" plain>添加组数</el-button></th>
          </tr>
          <tr>
            <th>
              裁判
            </th>
            <th>
              次数
            </th>
            <th>操作</th>
          </tr>

          <tr v-for="(item, index) in userScoreDetail.M_V_ScoreGroups">
            <td>
              <!-- {{ item.referee.RefereeName }} -->
              <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                placeholder="请选择">
                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                  :value="refer.RefereeId">
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input-number v-model="item.Score" controls-position="right" size="mini" style="width: 110px;"
                @change="calcScore"></el-input-number>

            </td>
            <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.M_V_ScoreGroups, index)"></i>
            </td>
          </tr>
        </table>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="submitScore">提交</el-button>
        <el-button type="info" size="small" @click="editPointDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MatchService from "@/request-server/request-services/match-services.js";
import SystemService from "@/request-server/request-services/system-services.js";

import Common from "@/utils/utils-common.js";
import Url from "../../../request-server/request-url.js";
import utilsCommon from "../../../utils/utils-common.js";
import userScoreData from '../../../data/user-socre.js';
import BrowserStorage from '@/utils/utils-browser-storage.js';
export default {
  data() {
    return {
      matchId: "",
      routeMatchId: "",
      match: null,
      matchRegions: [{ label: '全部', value: '' }],
      checkMatchRegion: [],
      allLoading: false,
      matchWholeSchedule: [],
      dataMd5: '',
      matchOptions: [],
      checkVenueConfigs: [],
      allMatchs: [],
      choiceMatchDialogVisible: false,
      choiceMatchVenueDialogVisible: false,

      showNullProject: true,
      refereeDialogVisible: false,
      timeInterval: null,
      autoRefresh: true,
      selectedUser: [],
      pushDialogVisible: false,
      matchContestantUserSchedule: [],
      onLineReferee: [],
      onLineRefereeCount: 0,
      activeNames: [0],
      scheduleRequestPending: false,
      renderedVenues: { 0: true },
      openProjects: {},
      renderedProjects: {},
      activeNames1: [],
      setUserStatusDialogVisible: false,
      setUserStatusForm: {
        UserId: "",
        Status: "",
        Score: "",
      },
      editPointDialogVisible: false,
      score: userScoreData.ScoreModel,
      userScore: {},
      userScoreDetail: {},
      referees: [],
      venueRegionTab: [],
      //场次数组
      matchVenueConfigs: [],
      simpleMode: true,
      vType:'新版'
    };
  },
  watch: {
    $route(to, from) {
      this.venueRegionTab = [];
      this.dataMd5 = '';
      this.matchWholeSchedule = [];
      this.activeNames = [0];
      this.renderedVenues = { 0: true };
      this.openProjects = {};
      this.renderedProjects = {};
      this.getMatchWholeSchedule(true);
      this.getAllMatchs();
      this.getAllReferee();
      this.getOnLineReferee();
      if (this.timeInterval == null) this.monitorData();
    },
  },
  beforeDestroy() {
    if (this.timeInterval) clearInterval(this.timeInterval);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    this.timeInterval = null;
    this.matchWholeSchedule = [];
    this.userScore = null;
    this.userScoreDetail = null;
    this.referees = [];
  },
  created() {
    this.routeMatchId = this.$route.params.id;
    this.getMatchWholeSchedule(true);
    this.getAllMatchs();
    this.getAllReferee();
    this.getOnLineReferee();
    if (this.timeInterval == null) this.monitorData();
    let simpleMode = BrowserStorage.getItem('match-controller-simpleMode');
    this.simpleMode = simpleMode ? simpleMode == 'true' : true;
    let vType = BrowserStorage.getItem('match-controller-vType');
    this.vType = vType ? vType : '新版';
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  methods: {
    handleVisibilityChange() {
      if (document.hidden) {
        if (this.timeInterval) clearInterval(this.timeInterval);
        this.timeInterval = null;
      } else if (this.timeInterval == null) {
        this.getMatchWholeSchedule(false);
        this.monitorData();
      }
    },
    getProjectKey(venue, project, projectIndex) {
      return `${venue.VenueId}:${project.ProjectId || project.ProjectName}:${projectIndex}`;
    },
    isVenueRendered(index) {
      return Boolean(this.renderedVenues[index]);
    },
    handleVenueCollapseChange(names) {
      (names || []).forEach(index => {
        this.$set(this.renderedVenues, index, true);
        const venue = this.matchWholeSchedule[index];
        if (venue && venue.Projects && venue.Projects.length) this.openFirstProject(venue);
      });
    },
    openFirstProject(venue) {
      const project = venue.Projects[0];
      if (!project) return;
      const key = this.getProjectKey(venue, project, 0);
      if (this.renderedProjects[key] === undefined) {
        this.$set(this.openProjects, key, true);
        this.$set(this.renderedProjects, key, true);
      }
    },
    toggleProject(venue, project, projectIndex) {
      const key = this.getProjectKey(venue, project, projectIndex);
      const open = !this.openProjects[key];
      this.$set(this.openProjects, key, open);
      if (open) this.$set(this.renderedProjects, key, true);
    },
    isProjectOpen(venue, project, projectIndex) {
      return Boolean(this.openProjects[this.getProjectKey(venue, project, projectIndex)]);
    },
    isProjectRendered(venue, project, projectIndex) {
      return Boolean(this.renderedProjects[this.getProjectKey(venue, project, projectIndex)]);
    },
    formatScheduleTime(value) {
      return value ? value.replace('T', ' ') : '';
    },
    prepareScheduleData(venues) {
      venues.forEach(venue => {
        (venue.Projects || []).forEach(project => {
          (project.ArrangeGroups || []).forEach(group => {
            (group.Regions || []).forEach(region => {
              const users = region.Users || [];
              users.forEach(user => {
                const projectTypeId = user.ProjectTypeId || project.ProjectTypeId || '';
                const gender = user.Gender !== undefined && user.Gender !== null
                  ? user.Gender
                  : user.ProjectGenderRule;
                user.IsSpeedProject = projectTypeId.toUpperCase() == 'F679B7E4-F852-4A2A-BAF2-EC21BE923826';
                const genderText = user.GenderText || '';
                user.GenderLabel = genderText == '男' ? '男子'
                  : genderText == '女' ? '女子'
                    : genderText || (gender == 0 ? '男子' : gender == 1 ? '女子' : gender == 2 ? '混合' : '');
                user.GenderTagType = gender == 1 ? 'danger' : gender == 2 ? 'warning' : '';
              });
              const hasWaiting = users.some(user => user.UserId && user.Status == 0);
              region.ContestantUsers = users;
              region.ActionState = {
                canPush: hasWaiting,
                canPushAgain: !hasWaiting && users.some(user => user.UserId && user.Status >= 2),
                canCancel: users.some(user => user.UserId && user.Status == 1),
                canComplete: users.some(user => user.UserId && (user.Status == 1 || user.Status == 2))
              };
            });
          });
        });
      });
      return venues;
    },
    getRegionStyle(region, group) {
      const userCount = Math.max((region.Users || []).length, 1);
      const usersPerRow = Math.min(userCount, 10);
      const regionCount = Math.max((group.Regions || []).length, 1);
      if (regionCount === 1) {
        return { '--users-per-row': usersPerRow, flex: '1 1 100%', minWidth: 0, maxWidth: '100%' };
      }
      return {
        '--users-per-row': usersPerRow,
        flex: `${usersPerRow} 0 ${usersPerRow * 110}px`,
        minWidth: `${Math.max(130, usersPerRow * 110)}px`
      };
    },
    vTypeChange() {
      BrowserStorage.setItem('match-controller-vType', this.vType);
    },
    handleMatchChange(event) {
      console.log(event);

    },
    modeChange() {
      console.log(this.simpleMode);
      BrowserStorage.setItem('match-controller-simpleMode', this.simpleMode);
    },
    showChoiceMatchDialogModel() {
      this.matchId = this.routeMatchId;
      this.handleMatchChange(this.matchId);
      this.choiceMatchDialogVisible = true;
    },
    showChoiceMatchVenueDialogModel() {
      console.log(this.matchOptions);
      this.matchId = this.routeMatchId;
      var data = this.matchOptions.filter(a => a.MatchId == this.matchId);
      console.log(data);
      this.matchVenueConfigs = data[0].MatchVenueConfigs;
      this.choiceMatchVenueDialogVisible = true;
    },

    monitorData() {
      if (this.timeInterval || document.hidden) return;
      this.timeInterval = setInterval(() => {
        if (this.routeMatchId != "" && this.autoRefresh && !this.choiceMatchDialogVisible && !this.choiceMatchVenueDialogVisible) {
          this.getMatchWholeSchedule(false);
          this.getOnLineReferee();
        }
      }, 5000);
    },

    getMatchWholeSchedule(loading = false) {
      this.getMatchScheduleUserV4(loading);
    },
    getMatchScheduleUserV4(loading = false) {
      let id = this.$route.params.id;
      if (id) {
        if (this.scheduleRequestPending) return;
        this.scheduleRequestPending = true;
        this.routeMatchId = id;
        this.$store.commit("matchIdCookie", id);
        if (loading) {
          this.allLoading = true;
        }

        // if (this.match == null) {
        //   MatchService.getMatchDetail({ matchId: this.routeMatchId }).then(
        //     (res) => {
        //       if (res.code == 0) {
        //         this.match = res.data;
        //         // this.match.Regions.forEach(region => {
        //         //   this.matchRegions.push({
        //         //     label: region.RegionName,
        //         //     value: region.RegionId
        //         //   });
        //         //   this.checkMatchRegion.push(region.RegionId);
        //         // });
        //       }
        //     }
        //   );
        // }


        let vids = this.checkVenueConfigs.join(',');
        MatchService.getMatchScheduleUserV4({ matchId: this.routeMatchId, dataMd5: this.dataMd5, rids: 'ALL', vids: vids, type: '' }).then(
          (res) => {
            if (res.code == 0) {
              if (id !== this.$route.params.id || res.data == null || res.data.result == null) return;
              const nextDataMd5 = res.data.dataMd5;
              if (this.dataMd5 && nextDataMd5 === this.dataMd5 && this.matchWholeSchedule.length) return;
              this.dataMd5 = nextDataMd5;
              this.matchWholeSchedule = Object.freeze(this.prepareScheduleData(res.data.result));
              if (this.matchWholeSchedule.length) this.openFirstProject(this.matchWholeSchedule[0]);
            }
          }
        ).finally(() => {
          this.scheduleRequestPending = false;
          this.allLoading = false;
          if (id !== this.$route.params.id) this.getMatchScheduleUserV4(true);
        });
      } else {
        //弹框选择赛事
        //获取开始中的赛事
        if (this.$store.state.matchIdCookie) {
          this.$router.replace(
            "/mainpage/match-controller-merge/" + this.$store.state.matchIdCookie
          );
        } else {
          this.choiceMatchDialogVisible = true;
        }
      }
    },
    getAllReferee() {
      SystemService.selectAllReferee().then(res => {
        if (res.code == 0) {
          this.referees = res.data;
        }
      })
    },
    getAllMatchs() {
      MatchService.selectMatchListByName({
        matchName: "",
        signupStatus: "",
        matchStatus: "",
      }).then((res) => {
        if (res.code == 0) {
          this.allMatchs = res.data;
          this.matchOptions = this.allMatchs;
          this.match = this.allMatchs.find(
            (a) => a.MatchId == this.routeMatchId
          );
        }
      });
    },
    getOnLineReferee() {
      return;
      if (this.routeMatchId != "") {
        MatchService.getOnLineReferee({ matchId: this.routeMatchId }).then(
          (res) => {
            this.onLineRefereeCount = 0;
            if (res.code == 0) {
              this.onLineReferee = res.data;
              if (
                this.onLineReferee != null &&
                this.onLineReferee.length != 0
              ) {
                this.onLineReferee.forEach((element) => {
                  element.RefereeTypes.forEach((type) => {
                    this.onLineRefereeCount += type.Referees
                      ? type.Referees.length
                      : 0;
                  });
                });
              }
            }
          }
        );
      }
    },
    getMatchSchedule() {

      return;
      MatchService.getMatchContestantUserSchedule({
        matchId: this.routeMatchId,
      }).then((res) => {
        if (res.code == 0) {
          this.matchContestantUserSchedule = res.data;
          this.matchContestantUserSchedule.forEach((element) => {
            let len = element.ContestantUsers.length;
            let insLen = 10 - len;
            for (let index = 0; index < insLen; index++) {
              element.ContestantUsers.push({
                UserId: "",
                UserName: "",
                ComeOnNum: "",
              });
            }
          });
        }
      });
    },
    pushMatchContestantUserSchedule(regionName, regionId, row) {
      this.$confirm(
        "确定要推送该组人员到" + regionName + "准备区吗？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          MatchService.pushMatchContestantUserSchedule({
            matchId: this.routeMatchId,
            regionId: regionId,
            userIds: row.ContestantUsers.filter((a) => a.UserId != "" && a.UserId.indexOf('null') == -1)
              .map((a) => a.UserId)
              .join(","),
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.data);
              this.getMatchSchedule();
              this.getMatchWholeSchedule();
            }
          });
        })
        .catch(() => { });
    },
    setMatchContestantUserComplete(row) {
      this.$confirm("是否确定该组运动员已比赛并且裁判打分完成？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          MatchService.setMatchContestantUserComplete({
            matchId: this.routeMatchId,
            userIds: row.ContestantUsers.filter((a) => a.UserId != "")
              .map((a) => a.UserId)
              .join(","),
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.data);
              this.getMatchSchedule();
              this.getMatchWholeSchedule();
            }
          });
        })
        .catch(() => { });
    },
    cancelMatchContestantUserSchedule1(row) {
      this.$confirm("确定要取消该轮人员出准备区吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          MatchService.cancelMatchContestantUserSchedule1({
            matchId: this.routeMatchId,
            userIds: row.ContestantUsers.filter((a) => a.UserId != "")
              .map((a) => a.UserId)
              .join(",")
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.data);
              this.getMatchSchedule();
              this.getMatchWholeSchedule();
            }
          });
        })
        .catch(() => { });
    },
    cancelMatchContestantUserSchedule(row) {
      this.$confirm("确定要取消该轮人员出准备区吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          MatchService.cancelMatchContestantUserSchedule({
            ScheduleId: row.ScheduleId,
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.data);
              this.getMatchSchedule();
              this.getMatchWholeSchedule();
            }
          });
        })
        .catch(() => { });
    },
    remoteMethod(query) {
      if (query !== "") {
        this.matchOptions = this.allMatchs.filter((item) => {
          return item.MatchName.indexOf(query) > -1;
        });
      } else {
        this.matchOptions = this.allMatchs;
      }
    },
    confirmChoiceMatch() {
      if (this.matchId != "" && this.matchId != this.routeMatchId) {
        this.$store.commit("matchIdCookie", this.matchId);
        this.$store.commit("matchIdCookie", this.checkVenueConfigs);
        this.match = null;
        this.checkMatchRegion = [];
        this.matchRegions = [];
        this.venueRegionTab = [];
        this.$router.replace("/mainpage/match-controller-merge/" + this.matchId);
      }
      this.choiceMatchDialogVisible = false;
    },
    showRefereeDialog() {
      //
      this.refereeDialogVisible = true;
    },
    showPushDialog() {
      this.getMatchSchedule();
      this.pushDialogVisible = true;
    },
    isShowPushBtn(row) {
      let arr = row.ContestantUsers.filter(
        (a) => a.UserId != "" && a.Status == 0
      );
      return arr.length > 0 ? true : false;
    },
    isShowAgainPushBtn(row) {
      if (this.isShowPushBtn(row)) return false;

      let arr = row.ContestantUsers.filter(
        (a) => a.UserId != "" && a.Status >= 2
      );
      return arr.length > 0 ? true : false;
    },
    isShowCancelPushBtn(row) {
      let arr = row.ContestantUsers.filter(
        (a) => a.UserId != "" && a.Status == 1
      );
      return arr.length > 0 ? true : false;
    },

    isShowCompleteBtn(row) {
      let arr = row.ContestantUsers.filter(
        (a) => a.UserId != "" && (a.Status == 1 || a.Status == 2)
      );
      return arr.length > 0 ? true : false;
    },

    setUserStatus(e) {
      let arr = e.split(":");
      this.setUserStatusForm.UserId = arr[0];
      this.setUserStatusForm.Status = arr[1];
      this.setUserStatusForm.Score = arr[2] == 0 || arr[1] == 4 ? "" : arr[2];
      this.setUserStatusDialogVisible = true;
    },
    submitSetUserStatus() {
      let data = utilsCommon.copyObj(this.setUserStatusForm);
      data.Score = data.Score ? data.Score : 0;
      MatchService.setUserStatus(data).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.data);
          this.getMatchSchedule();
          this.getMatchWholeSchedule();
          this.setUserStatusDialogVisible = false;
        }
      });
    },
    getStatusBtnType(status) {
      if (status == 0) return "";
      else if (status == 1) return "warning";
      else if (status == 2 || status == 3) return "success";
      else if (status == 4 || status == 5) return "info";
    },
    showEditPointDialog(uid) {
      MatchService.getMatchContestantUserScore({ userId: uid }).then((res) => {

        if (res.code == 0) {
          if (res.data != null) {
            this.userScore = res.data;
            if (this.userScore.AllScoreJson) {
              this.userScoreDetail = JSON.parse(this.userScore.AllScoreJson);
            } else {
              this.userScoreDetail = {
                User: {
                  UserId: uid
                },
                Project: {
                  ProjectTypeId: this.userScore.ProjectTypeId
                }
              }
            }
          }
          this.calcScore();
          this.editPointDialogVisible = true;
        }
      });
    },
    clacPatternMatchScore() {
      MatchService.clacPatternMatchScore(this.userScore).then((res) => {
        if (res.code == 0) {
          this.userScore.TotalScore = res.data;
        }
      });
    },
    editMatchContestantUserScore() {
      MatchService.editMatchContestantUserScore(this.userScore).then((res) => {
        if (res.code == 0) {
          this.editPointDialogVisible = false;
          this.userScore = null;
          this.getMatchSchedule();
          this.getMatchWholeSchedule();
        }
      });
    },
    editUserScore(user) {
      console.log(user);
      this.userScoreDetail = {
        User: {
          UserId: user.UserId
        },
        Project: {
          ProjectTypeId: user.ProjectTypeId
        },
        Times: [{
          referee: {
            RefereeName: '后台系统',
            RefereeId: '5F2373C5-F12B-4A8D-83B0-5AEE52198810'
          }, Times: user.Score
        }]
      };
      MatchService.editUserScoreDetail({ json: JSON.stringify(this.userScoreDetail) }).then(res => {
        if (res.code == 0) {
          this.$message.success(res.data);
        }
      })
    },
    delScoreGroupItem(arr, index) {
      this.$confirm("是否确认要删除该组评分", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          arr.splice(index, 1);
          this.calcScore();
        })
        .catch(() => { });
    },
    addScoreGroup(type) {
      let referee = {
        RefereeName: '后台系统',
        RefereeId: '5F2373C5-F12B-4A8D-83B0-5AEE52198810'
      };
      if (type == '扣分次数') {
        if (this.userScoreDetail.DeductPointItems == null) {
          this.userScoreDetail.DeductPointItems = [];
        }
        this.userScoreDetail.DeductPointItems.push({
          referee: referee, DeductPointCount: 0
        })
      } else if (type == '计次') {
        if (this.userScoreDetail.Times == null) {
          this.userScoreDetail.Times = [];
        }
        this.userScoreDetail.Times.push({
          referee: referee, Times: 0
        })
      } else if (type == '创意编排分') {
        if (this.userScoreDetail.CreativeArrangementGroups == null) {
          this.userScoreDetail.CreativeArrangementGroups = [];
        }
        this.userScoreDetail.CreativeArrangementGroups.push({
          referee: referee, Score: 0
        })
      } else if (type == '完成质量分') {
        if (this.userScoreDetail.CompletionQualityGroups == null) {
          this.userScoreDetail.CompletionQualityGroups = [];
        }
        this.userScoreDetail.CompletionQualityGroups.push({
          referee: referee, Score: 0
        })
      } else if (type == '难度分D') {
        if (this.userScoreDetail.D_ScoreGroups == null) {
          this.userScoreDetail.D_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.d.forEach(item => {
          data.Items.push({
            RankName: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.D_ScoreGroups.push(data);
      } else if (type == '重复难度U') {
        if (this.userScoreDetail.U_ScoreGroups == null) {
          this.userScoreDetail.U_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.u.forEach(item => {
          data.Items.push({
            RankName: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.U_ScoreGroups.push(data);
      } else if (type == 'Pa动作技能') {
        if (this.userScoreDetail.Pa_ScoreGroups == null) {
          this.userScoreDetail.Pa_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.p.pa.forEach(item => {
          data.Items.push({
            Record: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.Pa_ScoreGroups.push(data);
      } else if (type == 'Pr娱乐编排') {
        if (this.userScoreDetail.Pr_E_ScoreGroups == null) {
          this.userScoreDetail.Pr_E_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.p.pre.forEach(item => {
          data.Items.push({
            Record: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.Pr_E_ScoreGroups.push(data);
      } else if (type == 'Pr音乐运用') {
        if (this.userScoreDetail.Pr_M_ScoreGroups == null) {
          this.userScoreDetail.Pr_M_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.p.prm.forEach(item => {
          data.Items.push({
            Record: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.Pr_M_ScoreGroups.push(data);
      } else if (type == 'Fs形式风格') {
        if (this.userScoreDetail.FS_ScoreGroups == null) {
          this.userScoreDetail.FS_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.p.fs.forEach(item => {
          data.Items.push({
            Record: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.FS_ScoreGroups.push(data);
      } else if (type == '规定Q') {
        if (this.userScoreDetail.Q_ScoreGroups == null) {
          this.userScoreDetail.Q_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.q.forEach(item => {
          data.Items.push({
            Type: item.l,
            Score: item.t,
            MaxScoreValue: item.v
          })
        })
        this.userScoreDetail.Q_ScoreGroups.push(data);
      }
      else if (type == '【集体自编赛】规定Q') {
        if (this.userScoreDetail.Q_ScoreGroups == null) {
          this.userScoreDetail.Q_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.c_q.forEach(item => {
          data.Items.push({
            Type: item.l,
            Score: item.t,
            MaxScoreValue: item.v
          })
        })
        this.userScoreDetail.Q_ScoreGroups.push(data);
      }
      else if (type == 'Pa失误') {
        if (this.userScoreDetail.Mistake_Pa_ScoreGroups == null) {
          this.userScoreDetail.Mistake_Pa_ScoreGroups = [];
        }
        let data = {
          referee: referee, ScoreValue: 0.025, Score: 0
        }
        this.userScoreDetail.Mistake_Pa_ScoreGroups.push(data);
      } else if (type == 'Q失误') {
        if (this.userScoreDetail.Mistake_Q_ScoreGroups == null) {
          this.userScoreDetail.Mistake_Q_ScoreGroups = [];
        }
        let data = {
          referee: referee, ScoreValue: 0.025, Score: 0
        }
        this.userScoreDetail.Mistake_Q_ScoreGroups.push(data);
      } else if (type == '违例') {
        if (this.userScoreDetail.V_ScoreGroups == null) {
          this.userScoreDetail.V_ScoreGroups = [];
        }
        let data = {
          referee: referee, ScoreValue: 0.025, Score: 0
        }
        this.userScoreDetail.V_ScoreGroups.push(data);
      } else if (type == '【国内集体规定赛】完成质量') {
        if (this.userScoreDetail.CompletionQualityGroups == null) {
          this.userScoreDetail.CompletionQualityGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.ctr_cq.forEach(item => {
          data.Items.push({
            Type: item.t,
            Score: 0,
            MaxScoreValue: item.m
          })
        })
        this.userScoreDetail.CompletionQualityGroups.push(data);
      } else if (type == '【国内个人规定赛】完成质量') {
        if (this.userScoreDetail.CompletionQualityGroups == null) {
          this.userScoreDetail.CompletionQualityGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.cpr_cq.forEach(item => {
          data.Items.push({
            Type: item.t,
            Score: 0,
            MaxScoreValue: item.m
          })
        })
        this.userScoreDetail.CompletionQualityGroups.push(data);
      } else if (type == "【国内个人/集体规定赛】创意编排") {
        if (this.userScoreDetail.CreativeArrangementGroups == null) {
          this.userScoreDetail.CreativeArrangementGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.cr_ca.forEach(item => {
          data.Items.push({
            Type: item.t,
            Score: 0,
            MaxScoreValue: item.m
          })
        })
        this.userScoreDetail.CreativeArrangementGroups.push(data);
      } else if (type == '一级难度') {
        if (this.userScoreDetail.D1_ScoreGroups == null) {
          this.userScoreDetail.D1_ScoreGroups = [];
        }
        let data = {
          referee: referee, Level: this.score.c_d1.l, ScoreValue: this.score.c_d1.v, Score: 0
        }
        this.userScoreDetail.D1_ScoreGroups.push(data);

      } else if (type == '二级难度') {
        if (this.userScoreDetail.D2_ScoreGroups == null) {
          this.userScoreDetail.D2_ScoreGroups = [];
        }
        let data = {
          referee: referee, Level: this.score.c_d2.l, ScoreValue: this.score.c_d2.v, Score: 0
        }
        this.userScoreDetail.D2_ScoreGroups.push(data);

      } else if (type == '三级难度') {
        if (this.userScoreDetail.D3_ScoreGroups == null) {
          this.userScoreDetail.D3_ScoreGroups = [];
        }
        let data = {
          referee: referee, Level: this.score.c_d3.l, ScoreValue: this.score.c_d3.v, Score: 0
        }
        this.userScoreDetail.D3_ScoreGroups.push(data);

      } else if (type == '重复一级难度') {
        if (this.userScoreDetail.U1_ScoreGroups == null) {
          this.userScoreDetail.U1_ScoreGroups = [];
        }
        let data = {
          referee: referee, Level: this.score.c_u1.l, ScoreValue: this.score.c_u1.v, Score: 0
        }
        this.userScoreDetail.U1_ScoreGroups.push(data);

      } else if (type == '重复二级难度') {
        if (this.userScoreDetail.U2_ScoreGroups == null) {
          this.userScoreDetail.U2_ScoreGroups = [];
        }
        let data = {
          referee: referee, Level: this.score.c_u2.l, ScoreValue: this.score.c_u2.v, Score: 0
        }
        this.userScoreDetail.U2_ScoreGroups.push(data);

      } else if (type == '重复三级难度') {
        if (this.userScoreDetail.U3_ScoreGroups == null) {
          this.userScoreDetail.U3_ScoreGroups = [];
        }
        let data = {
          referee: referee, Level: this.score.c_u3.l, ScoreValue: this.score.c_u3.v, Score: 0
        }
        this.userScoreDetail.U3_ScoreGroups.push(data);
      } else if (type == '【国内表演赛/花样赛】创意编排') {
        if (this.userScoreDetail.CA_ScoreGroups == null) {
          this.userScoreDetail.CA_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.c_ca.forEach(item => {
          data.Items.push({
            Type: item.t,
            Score: 0,
            MaxScore: item.m
          })
        })
        this.userScoreDetail.CA_ScoreGroups.push(data);
      } else if (type == '【国内表演赛/花样赛】完成质量') {
        if (this.userScoreDetail.CQ_ScoreGroups == null) {
          this.userScoreDetail.CQ_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.c_cq.forEach(item => {
          data.Items.push({
            Type: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.CQ_ScoreGroups.push(data);
      } else if (type == '【国内表演赛】规定元素') {
        if (this.userScoreDetail.Q_ScoreGroups == null) {
          this.userScoreDetail.Q_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.c_q.forEach(item => {
          data.Items.push({
            Type: item.l,
            Frequency: item.t,
            MustFrequency: item.v
          })
        })
        this.userScoreDetail.Q_ScoreGroups.push(data);

      } else if (type == '【国内花样赛】规定元素') {
        if (this.userScoreDetail.Q_ScoreGroups == null) {
          this.userScoreDetail.Q_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.c_q2.forEach(item => {
          data.Items.push({
            Type: item.l,
            Frequency: this.userScoreDetail.Project.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
              && item.l == '互相配合' ? null : item.t,
            MustFrequency: item.v
          })
        })
        this.userScoreDetail.Q_ScoreGroups.push(data);
      }
      else if (type == '【精英级花样/表演赛】DP难度分') {
        if (this.userScoreDetail.DP_ScoreGroups == null) {
          this.userScoreDetail.DP_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.dp.forEach(item => {
          data.Items.push({
            RankName: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.DP_ScoreGroups.push(data);
      }
      else if (type == '【精英级花样/表演赛】DM难度分') {
        if (this.userScoreDetail.DM_ScoreGroups == null) {
          this.userScoreDetail.DM_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.dm.forEach(item => {
          data.Items.push({
            RankName: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.DM_ScoreGroups.push(data);
      }
      else if (type == '【精英级花样/表演赛】DR难度分') {
        if (this.userScoreDetail.DR_ScoreGroups == null) {
          this.userScoreDetail.DR_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.dr.forEach(item => {
          data.Items.push({
            RankName: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.DR_ScoreGroups.push(data);
      }
      else if (type == '【精英级花样/表演赛】DA难度分') {
        if (this.userScoreDetail.DA_ScoreGroups == null) {
          this.userScoreDetail.DA_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.da.forEach(item => {
          data.Items.push({
            RankName: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.DA_ScoreGroups.push(data);
      }
      else if (type == '【精英级花样/表演赛】DB难度分') {
        if (this.userScoreDetail.DB_ScoreGroups == null) {
          this.userScoreDetail.DB_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.db.forEach(item => {
          data.Items.push({
            RankName: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.DB_ScoreGroups.push(data);
      }
      else if (type == '【精英级花样/表演赛】DT难度分') {
        if (this.userScoreDetail.DT_ScoreGroups == null) {
          this.userScoreDetail.DT_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.dt.forEach(item => {
          data.Items.push({
            RankName: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.DT_ScoreGroups.push(data);
      }
      else if (type == '【精英级花样/表演赛】DJ难度分') {
        if (this.userScoreDetail.DJ_ScoreGroups == null) {
          this.userScoreDetail.DJ_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.dj.forEach(item => {
          data.Items.push({
            RankName: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.DJ_ScoreGroups.push(data);
      }
      else if (type == '【精英级花样/表演赛】DP重复难度分') {
        if (this.userScoreDetail.UDP_ScoreGroups == null) {
          this.userScoreDetail.UDP_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.u_dp.forEach(item => {
          data.Items.push({
            RankName: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.UDP_ScoreGroups.push(data);
      }
      else if (type == '【精英级花样/表演赛】DM重复难度分') {
        if (this.userScoreDetail.UDM_ScoreGroups == null) {
          this.userScoreDetail.UDM_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.u_dm.forEach(item => {
          data.Items.push({
            RankName: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.UDM_ScoreGroups.push(data);
      }
      else if (type == '【精英级花样/表演赛】DR重复难度分') {
        if (this.userScoreDetail.UDR_ScoreGroups == null) {
          this.userScoreDetail.UDR_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.u_dr.forEach(item => {
          data.Items.push({
            RankName: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.UDR_ScoreGroups.push(data);
      }
      else if (type == '【精英级花样/表演赛】DA重复难度分') {
        if (this.userScoreDetail.UDA_ScoreGroups == null) {
          this.userScoreDetail.UDA_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.u_da.forEach(item => {
          data.Items.push({
            RankName: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.UDA_ScoreGroups.push(data);
      }
      else if (type == '【精英级花样/表演赛】DB重复难度分') {
        if (this.userScoreDetail.UDB_ScoreGroups == null) {
          this.userScoreDetail.UDB_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.u_db.forEach(item => {
          data.Items.push({
            RankName: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.UDB_ScoreGroups.push(data);
      }
      else if (type == '【精英级花样/表演赛】DT重复难度分') {
        if (this.userScoreDetail.UDT_ScoreGroups == null) {
          this.userScoreDetail.UDT_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.u_dt.forEach(item => {
          data.Items.push({
            RankName: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.UDT_ScoreGroups.push(data);
      }
      else if (type == '【精英级花样/表演赛】表现P') {
        if (this.userScoreDetail.P_ScoreGroups == null) {
          this.userScoreDetail.P_ScoreGroups = [];
        }
        let data = {
          referee: referee,
          P_M_ScoreGroups: [],
          P_CQ_ScoreGroups: [],
          P_CA_ScoreGroups: [],
          P_R_ScoreGroups: [],
          P_V_ScoreGroups: []
        }
        this.score.p2.m.forEach(item => {
          data.P_M_ScoreGroups.push({
            Record: item.l,
            Score: item.t
          })
        })
        this.score.p2.cq.forEach(item => {
          data.P_CQ_ScoreGroups.push({
            Record: item.l,
            Score: item.t
          })
        })
        this.score.p2.ca.forEach(item => {
          data.P_CA_ScoreGroups.push({
            Record: item.l,
            Score: item.t
          })
        })
        this.score.p2.r.forEach(item => {
          data.P_R_ScoreGroups.push({
            Record: item.l,
            Score: item.t
          })
        })
        this.score.p2.v.forEach(item => {
          data.P_V_ScoreGroups.push({
            Record: item.l,
            Score: item.t
          })
        })
        this.userScoreDetail.P_ScoreGroups.push(data);
      }
      else if (type == '【精英级花样】规定元素Q-力量体操') {
        if (this.userScoreDetail.Q_P_ScoreGroups == null) {
          this.userScoreDetail.Q_P_ScoreGroups = [];
        }
        let data = {
          referee: referee,
          Items: []
        }
        this.score.q2.p.forEach(item => {
          data.Items.push({
            Level: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.Q_P_ScoreGroups.push(data);

      }
      else if (type == '【精英级花样】规定元素Q-多摇') {
        if (this.userScoreDetail.Q_M_ScoreGroups == null) {
          this.userScoreDetail.Q_M_ScoreGroups = [];
        }
        let data = {
          referee: referee,
          Items: []
        }
        this.score.q2.m.forEach(item => {
          data.Items.push({
            Level: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.Q_M_ScoreGroups.push(data);

      }
      else if (type == '【精英级花样】规定元素Q-绳子运用') {
        if (this.userScoreDetail.Q_R_ScoreGroups == null) {
          this.userScoreDetail.Q_R_ScoreGroups = [];
        }
        let data = {
          referee: referee,
          Items: []
        }
        this.score.q2.r.forEach(item => {
          data.Items.push({
            Level: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.Q_R_ScoreGroups.push(data);

      }
      else if (type == '【精英级花样】规定元素Q-互相配合') {

        if (this.userScoreDetail.Q_I_ScoreGroups == null) {
          this.userScoreDetail.Q_I_ScoreGroups = [];
        }
        let data = {
          referee: referee,
          Items: []
        }
        this.score.q2.initDistributePointRule.forEach(item => {
          data.Items.push({
            Level: item.l,
            Score: 0,
            ScoreValue: item.v
          })
        })
        this.userScoreDetail.Q_I_ScoreGroups.push(data);

      }
      else if (type == '【精英级花样/表演赛】失误m') {
        if (this.userScoreDetail.M_M_ScoreGroups == null) {
          this.userScoreDetail.M_M_ScoreGroups = [];
        }
        let data = {
          referee: referee,
          Score: 0
        }
        this.userScoreDetail.M_M_ScoreGroups.push(data);
      }
      else if (type == '【精英级花样】间歇b') {
        if (this.userScoreDetail.M_B_ScoreGroups == null) {
          this.userScoreDetail.M_B_ScoreGroups = [];
        }
        let data = {
          referee: referee,
          Score: 0
        }
        this.userScoreDetail.M_B_ScoreGroups.push(data);
      }
      else if (type == '【精英级花样/表演赛】违例v') {
        if (this.userScoreDetail.M_V_ScoreGroups == null) {
          this.userScoreDetail.M_V_ScoreGroups = [];
        }
        let data = {
          referee: referee,
          Score: 0
        }
        this.userScoreDetail.M_V_ScoreGroups.push(data);
      }
      else if (type == '【精英级表演赛】规定元素') {
        if (this.userScoreDetail.Q_ScoreGroups == null) {
          this.userScoreDetail.Q_ScoreGroups = [];
        }
        let data = {
          referee: referee, Items: []
        }
        this.score.e_q.forEach(item => {
          data.Items.push({
            Type: item.l,
            Frequency: item.t,
            MustFrequency: item.v
          })
        })
        this.userScoreDetail.Q_ScoreGroups.push(data);
      }
      console.log(this.userScoreDetail)
      this.calcScore();
    },
    submitScore() {
      MatchService.editUserScoreDetail({ json: JSON.stringify(this.userScoreDetail) }).then(res => {
        if (res.code == 0) {
          this.editPointDialogVisible = false;
          this.$message.success(res.data);
          this.getMatchWholeSchedule();
        }
      })
    },
    calcScore() {
      MatchService.calcScore({ json: JSON.stringify(this.userScoreDetail) }).then(res => {
        if (res.code == 0) {
          this.userScoreDetail = JSON.parse(res.data);
        }
      })
    },
    getTimelineColor(venue) {
      const now = new Date();
      const start = new Date(venue.VenueTime);
      const end = new Date(venue.VenueEndTime);

      if (now > end) {
        return '#67C23A'; // 已完成 - 绿色
      } else if (now >= start && now <= end) {
        return '#F56C6C'; // 进行中 - 红色
      } else {
        return '#909399'; // 未进行 - 灰色
      }
    },
    showRefereeScore() {
      var newWindow = window.open(window.origin + '#/match-referee-score-view/' + this.routeMatchId + '/' + this.match.Regions[0].RegionId, '_blank');
      if (newWindow) {
        // 尝试在新窗口加载后将其置为全屏
        newWindow.onload = function () {
          if (newWindow.document.fullscreenEnabled) {
            newWindow.document.documentElement.requestFullscreen().catch(err => {
              console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
            });
          }
        };
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.match-controller-container { min-height: 100%; background: #eef5fc; color: #2d4057; }
.controller-toolbar { color: #fff; background: linear-gradient(120deg, #4b8fd8, #6aa9e9) !important; box-shadow: 0 3px 12px rgba(64, 137, 210, .2); }
.controller-toolbar span { color: #f4f9ff; }
.schedule-list { margin: 14px 12px 0; border: 0; background: transparent; }
.venue-title { padding-left: 4px; color: #2d4057; font-size: 17px; font-weight: 650; letter-spacing: .2px; }
.venue-projects { max-height: calc(100vh - 160px); overflow: auto; padding: 10px 10px 18px; background: #eaf3fc; }
.project-section { width: 100%; min-width: 0; margin-bottom: 14px; overflow: hidden; border: 1px solid #cfdfee; border-radius: 7px; background: #fff; box-shadow: 0 3px 10px rgba(69, 125, 179, .09); }
.project-title { position: sticky; left: 0; z-index: 3; display: flex; align-items: center; justify-content: space-between; gap: 12px; width: 100%; height: 42px; padding: 0 15px; box-sizing: border-box; color: #304b68; background: linear-gradient(90deg, #f7fbff, #eaf4fd); border-bottom: 1px solid #d3e3f1; font-size: 16px; cursor: pointer; user-select: none; }
.project-title:hover { background: linear-gradient(90deg, #eff7fe, #dfedfa); }
.project-title-text { display: flex; align-items: center; gap: 12px; min-width: 0; }
.project-title-text span { color: #71879d; font-size: 13px; font-weight: 400; }
.project-title-text .project-group-count { color: #527495; border-color: #c8dced; background: #f5faff; }
.arrange-group { display: flex; min-height: 142px; border-bottom: 1px solid #dbe7f2; }
.arrange-group:last-child { border-bottom: 0; }
.group-number { position: sticky; left: 0; z-index: 2; display: flex; flex: 0 0 88px; align-items: center; justify-content: center; box-sizing: border-box; color: #496885; border-right: 1px solid #d5e3ef; background: #f3f8fd; font-size: 17px; font-weight: 600; }
.regions-row { display: flex; flex: 1; min-width: 0; align-items: stretch; }
.region-block { display: flex; min-width: 0; flex-direction: column; border-right: 1px solid #d9e6f1; background: #fff; }
.region-block:last-child { border-right: 0; }
.region-name { flex: 0 0 34px; line-height: 34px; text-align: center; color: #fff; background: linear-gradient(90deg, #6879ad, #7d8dc0); font-size: 15px; font-weight: 600; letter-spacing: .3px; }
.region-users { display: flex; flex: 1; flex-wrap: wrap; align-content: flex-start; }
.schedule-user { display: flex; flex: 0 0 calc(100% / var(--users-per-row)); min-width: 0; flex-direction: column; box-sizing: border-box; text-align: center; border-right: 1px solid #e5eaf0; border-bottom: 1px solid #e5eaf0; background: #fff; transition: background-color .15s ease; }
.schedule-user:hover { background: #f5faff; }
.schedule-user:last-child { border-right: 0; }
.user-number { position: relative; min-height: 30px; padding: 5px 34px 5px 4px; box-sizing: border-box; color: #304b68; border-bottom: 1px solid #e1ebf4; background: #f8fbff; font-weight: 700; }
.gender-tag { position: absolute; top: 3px; right: 3px; padding: 0 4px; }
.user-group { min-height: 20px; padding: 3px 4px; overflow: hidden; color: #718096; border-bottom: 1px solid #edf0f3; font-size: 12px; line-height: 20px; text-overflow: ellipsis; white-space: nowrap; }
.user-name { min-height: 40px; padding: 7px 5px; overflow: hidden; box-sizing: border-box; color: #202f3d; line-height: 20px; overflow-wrap: anywhere; white-space: normal; font-weight: 650; }
.user-unit { min-height: 40px; padding: 0 5px 5px; overflow: hidden; color: #6c7a89; font-size: 12px; line-height: 18px; overflow-wrap: anywhere; }
.user-status { display: flex; align-items: center; justify-content: center; flex-direction: column; gap: 6px; margin-top: auto; padding: 5px; }
.user-score-row { display: flex; min-height: 28px; align-items: center; justify-content: center; }
.user-score { color: #3d83c5; text-decoration: underline; cursor: pointer; font-weight: 700; }
.speed-score-input { width: 72px; }
:deep(.speed-score-input .el-input__inner) { padding: 0 5px; text-align: center; }
.region-actions { display: flex; flex: 0 0 40px; align-items: center; justify-content: center; padding: 4px; border-top: 1px solid #d8e5f0; background: #f4f9fd; }
.region-actions .el-button + .el-button { margin-left: 6px; }

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.box-card {
  margin-bottom: 20px;
}

.title {
  background-color: #e3e3e3;
  font-weight: 600;
  font-size: 16px;
}

.title .schedule-cell {
  height: 30px;
  line-height: 30px;
}

.schedule-cell {
  border: 1px solid #b3b1b1;
  box-sizing: border-box;
  min-height: 30px;
  line-height: 30px;
}

.schedule-user-cell {
  border-right: 1px solid #b3b1b1;
  border-bottom: 1px solid #b3b1b1;
  box-sizing: border-box;
}

table {
  border-collapse: collapse;
  margin: 10px;
  /* 合并边框 */
}

th,
td {
  border: 2px solid #e3e3e3;
  /* 设置边框宽度为2px，颜色为蓝色 */
  width: 120px;
  text-align: center;
  height: 35px;
}

th {
  background-color: #d3d2d2;
  color: #000;
}

.score-group-item {
  margin-top: 10px;
}

.el-icon-delete {
  color: red;
  cursor: pointer;
}

.el-timeline .item {
  margin: 0;
}

:deep(.el-collapse-item__header) {
  height: 36px !important;
  line-height: 36px !important;
  padding: 0 12px;
  color: #2d4057;
  border: 1px solid #cfdfee;
  border-radius: 7px 7px 0 0;
  background: #fff;
  box-shadow: 0 2px 8px rgba(69, 125, 179, .08);
}

:deep(.el-collapse-item__arrow) {
  color: #5c8fc1;
  font-weight: 700;
}

:deep(.el-collapse-item__content) {
  padding-bottom: 0;
}

:deep(.el-collapse-item__wrap),
:deep(.el-collapse-transition-enter-active),
:deep(.el-collapse-transition-leave-active) {
  transition: none !important;
}
</style>

